import { ResumeAnalysis } from "lib/resume-scoring/resume-analysis/resume-analyse-types";
import Image from "next/image";
import Link from "next/link";
import { SectionCard } from "./SectionCard";
import { StatusItem } from "./StatusItem";

export const OverallCard = ({
  score,
  maxScore,
  analysis,
  className = "",
}: {
  score: number;
  maxScore: number;
  analysis: ResumeAnalysis;
  className?: string;
}) => {
  const isBulletPointOptimal =
    analysis.overallAnalysis.totalNumberOfBulletPoints >= 12 && 
    analysis.overallAnalysis.totalNumberOfBulletPoints <= 20;

  const isWordCountOptimal =
    analysis.overallAnalysis.totalNumberOfWords >= 400 &&
    analysis.overallAnalysis.totalNumberOfWords <= 600;

  const hasCustomSection = analysis.custom.descriptionAnalysis.length > 0;

  const hasMajorIssues =
    analysis.overallAnalysis.repeatedActionVerbs.count > 0 ||
    analysis.overallAnalysis.repeatedPhrases.count > 0 ||
    analysis.overallAnalysis.repeatedSentences.count > 0 ||
    analysis.overallAnalysis.totalNumberOfWords < 400 ||
    analysis.overallAnalysis.totalNumberOfWords > 600 ||
    !isBulletPointOptimal ||
    !hasCustomSection ||
    !analysis.overallAnalysis.isDateStructureConsistent;

  const bulletStatement = 
    analysis.overallAnalysis.totalNumberOfBulletPoints < 12 
      ? "Less bullet points" 
      : analysis.overallAnalysis.totalNumberOfBulletPoints > 20 
        ? "More bullet points" 
        : "Optimal bullet points";

  return (
    <SectionCard
      title="Miscellaneous"
      icon="overall"
      score={score}
      maxScore={maxScore}
      detailsLink="/score-check/overall"
      className={className}
    >
      <ul className="mb-3 mt-3 gap-y-3 overflow-auto">
        {hasMajorIssues ? (
          <StatusItem
            icon="issue"
            title="Major Issues"
            subtitle="Impacting score"
            status="error"
          />
        ) : (
          <StatusItem
            icon="noIssue"
            title="No issue found"
            subtitle="Good impact in score"
            status="success"
          />
        )}

        <StatusItem
          icon="bulletPoints"
          title={bulletStatement}
          subtitle="Impacting score"
          status={isBulletPointOptimal ? "success" : "error"}
        />

        {/* Custom section check is commented out in the original code */}
        {/* <StatusItem
          icon="customSection"
          title={`${hasCustomSection ? "" : "No"} custom section`}
          subtitle={hasCustomSection ? "Good impact on score" : "Suggested to add"}
          status={hasCustomSection ? "success" : "error"}
        /> */}
      </ul>
    </SectionCard>
  );
};
